export default {
    grey: {
        100: '#e7e9ea',
        200: '#e1e1e1',
        300: '#d6d6d6',
        400: '#cfd2d4',
        500: '#999b9d',
        600: '#808080',
        700: '#777',
        800: '#595959',
        900: '#484848'
    },

    iron: '#d7dbdd',
    nevada: 'rgb(78, 92, 103)',
    lightGreyShadow: 'rgba(0, 0, 0, 0.3)',
    silverDark: '#cdcdcd',
    emperor: '#555555',
    buttercup: '#f69e13',
    porcelain: '#e7e9ea',
    scandal: '#c7fbe6',
    mercury: '#e6e6e6',
    hitGray: '#adb6bc',
    oxfordBlue: '#3b4e5e'
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/colours.js